<template>
  <div class="sights page-component">
    <div class="container">
      <h1 class="text-center">{{ title }}</h1>
      <div class="grid-vertical-cards">
        <SightItem
          v-for="Sight in Sights"
          :key="Sight.id"
          :image ="Sight.sights_image"
          :title="Sight.sights_title[0].text"
          :text="Sight.sights_text"
          :meta="Sight.sights_meta"
          :link="Sight.sights_link"
        ></SightItem>
      </div>
    </div>
  </div>
</template>

<script>
import SightItem from './SightItem.vue'
import EventBus from '../../EventBus'

export default {
  components: { SightItem },
  name: 'Sights',
  props: ['title'],
  data() {
    return {
      Sights: null
    }
  },
  methods: {
    async getContent(language) {
      let document = await this.$prismic.client.query(
        this.$prismic.Predicates.at('document.type', 'sights'), {lang: language}
      )
      if (document) {
        this.Sights = document.results.map(result => result = {
            sights_image: result.data.sights_image,
            sights_title: result.data.sights_title,
            sights_text: result.data.sights_text,
            sights_meta: this.addLineBreaks(result.data.sights_meta),
            sights_link: result.data.sights_link
          })
      }
    },
    addLineBreaks (str) {
      if (!str) {
        return null
      }
      return str.replace(/\r?\n|\r/g, "<br />")
    }
  },
  async created() {
    await this.getContent(window.KriensTourismus.language)

    // Listen to Language Change
    EventBus.$on(EventBus.constants.LANGUAGE_CHANGED, (language) => this.getContent(language))
  }
}
</script>